// extracted by mini-css-extract-plugin
export default {"card":"Card_card__t0hUL","image":"Card_image__D4u2s","buttons":"Card_buttons__SPYFu","buttonSecondary":"Card_buttonSecondary__XTkKL","icon":"Card_icon__EIS91"};